import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAddOnRules } from '../../common/hooks/useAddOnRules.js';
import { additionalServicesMsg, t } from '../../common/i18n/index.js';
import { deepEqual } from '../../common/utils/objectUtils.js';
import { getSubscriptionStatusForEmployee } from '../../common/utils/subscriptionUtils';
import { useAuth } from '../../public/site/AuthProvider.js';
import { LinkableAccordion } from '../LinkableAccordion/index.js';
import { AdditionalServicesAccordionContent } from '../SubscriptionDetails/AdditionalServicesContent.js';
import type { SubscriptionCategory } from '../../common/enums.js';
import type { Subscription } from '../../generated/api/subscription.js';
import type { State } from '../../selfservice/common/store.js';

export const EoeAdditionalServicesAccordion = ({
  subscription,
  category,
}: {
  subscription: Subscription;
  category: SubscriptionCategory;
}) => {
  const { authenticatedUser } = useAuth();
  const pendingSubscriptionActions = useSelector(
    (state: State) => state?.selfservice?.pendingSubscriptionActions,
    deepEqual
  );
  const [rulesRequested, setRulesRequested] = useState(false);
  const { associations, dependencies } = useAddOnRules({
    loadSubscriptionRules: rulesRequested,
    loadMobilePbxRules: rulesRequested,
  });
  const isMobileIdEnabledForEoEUser = authenticatedUser?.enabledFeatureFlags?.includes('mobileIdEoe') || false;
  const changeOfferAllowed =
    getSubscriptionStatusForEmployee(subscription, pendingSubscriptionActions?.items).changeOfferAllowed || false;

  return (
    <LinkableAccordion
      id="additonal-services"
      heading={t.LXSR(additionalServicesMsg)}
      headingLevel="h3"
      onOpen={() => setRulesRequested(true)}
    >
      <AdditionalServicesAccordionContent
        subscription={subscription}
        category={category}
        addOnAssociations={associations}
        addOnDependencies={dependencies}
        isMobileIdEnabledForEoeUser={isMobileIdEnabledForEoEUser}
        changeOfferAllowed={changeOfferAllowed}
      />
    </LinkableAccordion>
  );
};
